export function mapTablePropsWithResult(tableProps, { page }) {
  return {
    ...tableProps,
    pageProps: {
      ...tableProps.pageProps,
      ...page,
    },
  };
}
